export const GET_ALERT_SETTINGS_REQUEST_V3 = 'GET_ALERT_SETTINGS_REQUEST_V3';
export const GET_ALERT_SETTINGS_SUCCESS_V3 = 'GET_ALERT_SETTINGS_SUCCESS_V3';
export const GET_ALERT_SETTINGS_ERROR_V3 = 'GET_ALERT_SETTINGS_ERROR_V3';
export const CREATE_ALERT_SETTING_REQUEST_V3 =
  'CREATE_ALERT_SETTING_REQUEST_V3';
export const CREATE_ALERT_SETTING_SUCCESS_V3 =
  'CREATE_ALERT_SETTING_SUCCESS_V3';
export const CREATE_ALERT_SETTING_ERROR_V3 = 'CREATE_ALERT_SETTING_ERROR_V3';
export const DELETE_ALERT_SETTING_REQUEST_V3 =
  'DELETE_ALERT_SETTING_REQUEST_V3';
export const DELETE_ALERT_SETTING_SUCCESS_V3 =
  'DELETE_ALERT_SETTING_SUCCESS_V3';
export const DELETE_ALERT_SETTING_ERROR_V3 = 'DELETE_ALERT_SETTING_ERROR_V3';
export const UPDATE_ALERT_SETTING_REQUEST_V3 =
  'UPDATE_ALERT_SETTING_REQUEST_V3';
export const UPDATE_ALERT_SETTING_SUCCESS_V3 =
  'UPDATE_ALERT_SETTING_SUCCESS_V3';
export const UPDATE_ALERT_SETTING_ERROR_V3 = 'UPDATE_ALERT_SETTING_ERROR_V3';

export const GET_WHATSAPP_GROUP_REQUEST = 'GET_WHATSAPP_GROUP_REQUEST';
export const GET_WHATSAPP_GROUP_SUCCESS = 'GET_WHATSAPP_GROUP_SUCCESS';
export const GET_WHATSAPP_GROUP_ERROR = 'GET_WHATSAPP_GROUP_ERROR';
